<template>
  <v-container id="dashboard-view" fluid tag="section">
    <!-- <v-row>
      <v-col
        v-for="({ actionIcon, actionText, ...attrs }, i) in stats"
        :key="i"
        cols="12"
        sm="6"
        md="6"
        lg="3"
      >
        <material-stat-card v-bind="attrs">
          <template #actions>
            <v-icon class="mr-2" small v-text="actionIcon" />
            <div class="text-truncate">
              {{ actionText }}
            </div>
          </template>
        </material-stat-card>
      </v-col>
    </v-row> -->

    <v-row>
      <v-col cols="12">
        <v-card outlined class="mt-2">
          <v-card-title class="text-subtitle-1 py-2">
            Daftar Kapal Terbaru
          </v-card-title>
          <v-card-text class="pt-0">
            <div v-if="latestVessels.length" class="vessel-table-wrap">
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">KV</th>
                      <th class="text-left">Nama Kapal</th>
                      <th class="text-left">Voyage</th>
                      <th class="text-left">Tgl Berangkat</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(vessel, idx) in latestVessels" :key="idx">
                      <td>{{ vessel.kv }}</td>
                      <td>{{ vessel.nama_kapal || "-" }}</td>
                      <td>{{ vessel.voy || "-" }}</td>
                      <td>{{ formatDate(vessel.tgl_berangkat) }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
            <p v-else class="text--secondary text-body-2 mb-0">
              Belum ada data kapal.
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card outlined class="mt-2">
          <v-card-title class="text-subtitle-1 py-2">
            Daftar Container Belum Ada Kapal
          </v-card-title>
          <v-card-text class="pt-0">
            <div
              v-if="containersWithoutVessel.length"
              class="vessel-table-wrap"
            >
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">KC</th>
                      <th class="text-left">No Container</th>
                      <th class="text-left">Jenis</th>
                      <th class="text-left">Tgl Stuffing</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(container, idx) in containersWithoutVessel"
                      :key="`${container.kc}-${idx}`"
                    >
                      <td>{{ container.kc || "-" }}</td>
                      <td>{{ container.no_container || "-" }}</td>
                      <td>{{ container.jenis_container || "-" }}</td>
                      <td>{{ formatDate(container.tgl_stuffing) }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
            <p v-else class="text--secondary text-body-2 mb-0">
              Tidak ada container yang belum ada kapal.
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card outlined class="mt-2 mb-4">
          <v-card-title class="text-subtitle-1 py-2">
            TTB BLM Stuffing
          </v-card-title>
          <v-card-text class="pt-0">
            <div v-if="ttbBelumStuffing.length" class="vessel-table-wrap">
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Tgl Terima</th>
                      <th class="text-left">Kode TTB</th>
                      <th class="text-left">No TTB</th>
                      <th class="text-left">Penerima</th>
                      <th class="text-right">Sisa Koli</th>
                      <th class="text-right">Kubikasi (M3)</th>
                      <th class="text-right">Tonase (Ton)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(ttb, idx) in ttbBelumStuffing"
                      :key="`${ttb.kodettb}-${idx}`"
                    >
                      <td>{{ formatDate(ttb.tgl) }}</td>
                      <td>{{ ttb.kodettb || "-" }}</td>
                      <td>{{ ttb.nottb || "-" }}</td>
                      <td>
                        {{
                          ttb.penerima_detil && ttb.penerima_detil.nama_lengkap
                            ? ttb.penerima_detil.nama_lengkap
                            : "-"
                        }}
                      </td>
                      <td class="text-right">
                        {{ formatNumber(ttb.sisa_koli) }}
                      </td>
                      <td class="text-right">
                        {{ formatDecimal(ttb.total_m3) }}
                      </td>
                      <td class="text-right">
                        {{ formatDecimal(ttb.total_ton) }}
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="5" class="text-right">
                        <b>Total Keseluruhan:</b>
                      </td>
                      <td class="text-right">
                        <b>{{ formatDecimal(ttbBelumStuffingGrandTotalM3) }}</b>
                      </td>
                      <td class="text-right">
                        <b>{{
                          formatDecimal(ttbBelumStuffingGrandTotalTon)
                        }}</b>
                      </td>
                    </tr>
                  </tfoot>
                </template>
              </v-simple-table>
            </div>
            <p v-else class="text--secondary text-body-2 mb-0">
              Tidak ada TTB yang belum stuffing.
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "DashboardView",

  data: () => ({
    stats: [
      {
        actionIcon: "",
        actionText: "",
        color: "#FD9A13",
        icon: "mdi-clipboard-outline",
        title: "Total TTB",
        value: ""
      },
      {
        actionIcon: "",
        actionText: "",
        color: "primary",
        icon: "mdi-truck",
        title: "Total Container",
        value: ""
      },
      {
        actionIcon: "",
        actionText: "",
        color: "success",
        icon: "mdi-ferry",
        title: "Total Kapal",
        value: ""
      }
    ],
    latestVessels: [],
    containersWithoutVessel: [],
    ttbBelumStuffing: [],
    ttbBelumStuffingGrandTotalM3: 0,
    ttbBelumStuffingGrandTotalTon: 0
  }),
  methods: {
    getStats() {
      axios
        .get("info/stats")
        .then(response => {
          this.stats[0].value = response.data.total_ttb ?? 0;
          this.stats[1].value = response.data.total_container ?? 0;
          this.stats[2].value = response.data.total_vessel ?? 0;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getLatestVessels() {
      axios
        .get("vessel")
        .then(response => {
          this.latestVessels = (response.data || []).slice(0, 5);
        })
        .catch(error => {
          console.log(error);
        });
    },
    getContainersWithoutVessel() {
      axios
        .get("container-belum-berangkat")
        .then(response => {
          this.containersWithoutVessel = (response.data || []).slice(0, 10);
        })
        .catch(error => {
          console.log(error);
        });
    },
    getTtbBelumStuffing() {
      axios
        .get("laporan/ttb-belum-masuk-container")
        .then(response => {
          this.ttbBelumStuffing = response.data?.data || [];
          this.ttbBelumStuffingGrandTotalM3 =
            Number(response.data?.grand_total_m3) || 0;
          this.ttbBelumStuffingGrandTotalTon =
            Number(response.data?.grand_total_ton) || 0;
        })
        .catch(error => {
          console.log(error);
        });
    },
    formatDate(dateValue) {
      if (!dateValue) {
        return "-";
      }

      const date = new Date(dateValue);
      if (Number.isNaN(date.getTime())) {
        return "-";
      }

      return `${String(date.getDate()).padStart(2, "0")}-${String(
        date.getMonth() + 1
      ).padStart(2, "0")}-${date.getFullYear()}`;
    },
    formatNumber(value) {
      return new Intl.NumberFormat("id-ID").format(value || 0);
    },
    formatDecimal(value) {
      return new Intl.NumberFormat("id-ID", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(Number(value) || 0);
    }
  },
  created() {
    this.getStats();
    this.getLatestVessels();
    this.getContainersWithoutVessel();
    this.getTtbBelumStuffing();
  }
};
</script>

<style scoped>
.vessel-table-wrap {
  max-height: 420px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.vessel-table-wrap :deep(table) {
  min-width: 840px;
}
</style>
